import type { HandledByV1 } from '@flux/shared';
import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge.js';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip.js';

/**
 * Étapes faites par la v1 PHP pendant la bascule (`04` §10), que la v2 avait
 * calculées en shadow ou en simulation : badge « V1 » à la place de
 * « Simulé », et une phrase qui dit ce que la v1 a fait.
 */
export function v1Messages(handledByV1: HandledByV1 | null | undefined): string[] {
  if (!handledByV1) {
    return [];
  }
  const messages: string[] = [];
  if (handledByV1.transmission) {
    messages.push('Transmise à Martelet par l’application Flux V1.');
  }
  if (handledByV1.shipping) {
    messages.push('Expédition remontée dans Shopify par l’application Flux V1.');
  }
  return messages;
}

export function V1Badge({ handledByV1 }: { handledByV1: HandledByV1 | null | undefined }): JSX.Element | null {
  const messages = v1Messages(handledByV1);
  if (messages.length === 0) {
    return null;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-default" tabIndex={0}>
          <Badge tone="gray">V1</Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <ul className="flex flex-col gap-1">
          {messages.map((message) => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      </TooltipContent>
    </Tooltip>
  );
}

/** Les mêmes phrases, en clair sous l'en-tête d'une fiche. */
export function V1Notice({ handledByV1 }: { handledByV1: HandledByV1 | null | undefined }): JSX.Element | null {
  const messages = v1Messages(handledByV1);
  if (messages.length === 0) {
    return null;
  }
  return <span className="text-xs text-muted-foreground">{messages.join(' ')}</span>;
}
